import type { JsonApiResponse } from 'json-api-normalizer';

import api from 'api/apiInstance';
import { mapFormData } from 'helpers/formData';

export interface AdviceRoomDocumentReorderPatchOptions {
  newPosition: number;
}

export function adviceRoomDocumentReorderApi(path: string) {
  return {
    path,
    PATCH: (params: AdviceRoomDocumentReorderPatchOptions) =>
      api.patch<JsonApiResponse>(path, {
        data: {
          attributes: mapFormData(params),
        },
      }),
  };
}
